import { Routes } from '@angular/router';
import { nafathGuard } from '@common/guards/nafath.guard';
import {
  wathiqGuard,
  wathiqPreviewGuard,
  wathiqSuccessGuard,
  wathiqFormGuard,
} from '@common/guards/wathiq.guards';
import { CanDeactivateGuard } from '@common/guards/can-deactivate.guard';

const authRoutes: Routes = [
  {
    path: 'auth',
    loadComponent: () =>
      import('./auth.component').then(mod => mod.AuthComponent),
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./login/login.component').then(mod => mod.LoginComponent),
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./mobile-number/mobile-number.component').then(
                mod => mod.MobileNumberComponent
              ),
          },
          {
            path: 'un-claimable',
            loadComponent: () =>
              import('./un-claimable/un-claimable.component').then(
                mod => mod.UnClaimableComponent
              ),
          },
          {
            path: 'password',
            loadComponent: () =>
              import('./password/password.component').then(
                mod => mod.PasswordComponent
              ),
          },
        ],
      },
      {
        path: 'login',
        loadComponent: () =>
          import('./login/login.component').then(mod => mod.LoginComponent),
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./mobile-number/mobile-number.component').then(
                mod => mod.MobileNumberComponent
              ),
          },
          {
            path: 'un-claimable',
            loadComponent: () =>
              import('./un-claimable/un-claimable.component').then(
                mod => mod.UnClaimableComponent
              ),
          },
          {
            path: 'password',
            loadComponent: () =>
              import('./password/password.component').then(
                mod => mod.PasswordComponent
              ),
          },
        ],
      },
      {
        path: 'signup',
        loadComponent: () =>
          import('./signup/signup.component').then(mod => mod.SignupComponent),

        children: [
          {
            path: '',
            loadComponent: () =>
              import('./otp/otp.component').then(mod => mod.OtpComponent),
          },
          {
            path: 'investor-type',
            loadComponent: () =>
              import('./investor-type/investor-type.component').then(
                mod => mod.InvestorTypeComponent
              ),
          },
          {
            path: 'investor-email-password',
            loadComponent: () =>
              import('./investor-email-password/investor-email-password.component').then(
                mod => mod.InvestorEmailPasswordComponent
              ),
          },
          {
            path: 'success-signup',
            loadComponent: () =>
              import('./success-auth/success-auth.component').then(
                mod => mod.SuccessAuthComponent
              ),
          },
        ],
      },
      {
        path: 'forgot-password',
        loadComponent: () =>
          import('./forgot-password/forgot-password.component').then(
            mod => mod.ForgotPasswordComponent
          ),
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./activate-or-reset-password/activate-or-reset-password.component').then(
                mod => mod.ActivateOrResetPasswordComponent
              ),
          },
          {
            path: 'forgot-password-success',
            loadComponent: () =>
              import('./success-auth/success-auth.component').then(
                mod => mod.SuccessAuthComponent
              ),
          },
        ],
      },
      {
        path: 'claim-account',
        loadComponent: () =>
          import('./claim-account/claim-account.component').then(
            mod => mod.ClaimAccountComponent
          ),
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./otp/otp.component').then(mod => mod.OtpComponent),
          },
          {
            path: 'activate-password',
            loadComponent: () =>
              import('./activate-or-reset-password/activate-or-reset-password.component').then(
                mod => mod.ActivateOrResetPasswordComponent
              ),
          },
          {
            path: 'activation-success',
            loadComponent: () =>
              import('./success-auth/success-auth.component').then(
                mod => mod.SuccessAuthComponent
              ),
          },
        ],
      },

      {
        path: 'kyc',
        loadComponent: () =>
          import('../auth/kyc/kyc.component').then(mod => mod.KycComponent),
      },
      {
        path: 'nafath',
        canActivate: [nafathGuard],
        loadComponent: () =>
          import('./nafath/nafath.component').then(mod => mod.NafathComponent),
      },
      {
        path: 'wakala',
        loadComponent: () =>
          import('./wakala/wakala.component').then(mod => mod.WakalaComponent),
      },
      {
        path: 'wathiq',
        canActivate: [wathiqGuard],
        loadComponent: () =>
          import('./wathiq/wathiq.component').then(mod => mod.WathiqComponent),
      },
      {
        path: 'wathiq-success',
        canActivate: [wathiqSuccessGuard],
        loadComponent: () =>
          import('./wathiq/wathiq-success/wathiq-success.component').then(
            mod => mod.WathiqSuccessComponent
          ),
      },
      {
        path: 'wathiq-preview',
        canActivate: [wathiqPreviewGuard],
        loadComponent: () =>
          import('./wathiq/wathiq-preview/wathiq-preview.component').then(
            mod => mod.WathiqPreviewComponent
          ),
        canDeactivate: [CanDeactivateGuard],
      },
      {
        path: 'wathiq-form',
        canActivate: [wathiqFormGuard],
        loadComponent: () =>
          import('./wathiq/wathiq-form/wathiq-form.component').then(
            mod => mod.WathiqFormComponent
          ),
      },
    ],
  },
];

export default authRoutes;
